import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const mobilePriceCardSelector = '.js-mobile-price-card';
	const expandButtonSelector = '.js-mobile-price-card-expand-button';
	const expandedContentSelector = '.js-mobile-price-card-inner-blocks';
	const cards = document.querySelectorAll(mobilePriceCardSelector);

	if (!cards.length) {
		return;
	}
	const { ExpandButton } = await import('./expand-button');

	cards.forEach((cardElement) => {
		const expandButton = new ExpandButton({
			cardElement,
			expandButtonSelector,
			expandedContentSelector,
		});
		expandButton.init();
	});
});
